module.exports = __webpack_public_path__ + "img/wavesthumb.b2031bc7.gif";